import EtarPage from '@/views/etar/etarPage.vue'
import EtarTable from '@/views/etar/etarTable.vue'
// import { state } from '@/views/etar/etarStore'

export default [
  {
    path: '/e-tar',
    name: 'E-TAR',
    component: EtarPage,
    meta: {
      title: 'E-TAR',
      subtitle: 'Electronic Training Achievement Record',
      childrenInNav: false,
      requiresAuth: true,
      authorizedUsers: [4],
    },
    children: [
      {
        path: '/e-tar/:etarDetId',
        name: 'EtarTable',
        component: EtarTable,
        props: true,
        meta: {
          title: 'E-TAR',
          subtitle: 'Electronic Training Achievement Record',
          requiresAuth: true,
          authorizedUsers: [4],
        },
      },
    ],
  },
]
